export const OUTGOINGCALL_ERRORS = {
    FETCH_PENDING_OUTGOINGCALL_ERROR: "Error fetching pending outgoing calls:",
    SEARCH_FAILED: "Failed to search for customer.",
    ADD_ONGOING_CALL_ERROR: "Error adding ongoing call:",
};

export const OUTGOING_CALLS_ERRORS = {
    SEARCH_FAILED: "Failed to search for customer.",
    COMPLETE_ONGOING_CALL_ERROR: "Error completing ongoing call:",
}

export const OUTGOING_CALL_STRING = {
    SEARCH_CUSTOMER_TITLE: "Search Customer (Outgoing)",
    ENTER_PHONE_NUMBER: "Enter phone number",
    ENTER_SEARCH_TEXT: "Enter search text",
    SEARCH: "Search",
    SEARCHING: "Searching...",
    CANCEL: "Cancel",
};

export const VALIDATION_MESSAGES = {
    SEARCH_TEXT_REQUIRED: "Search text is required.",
    SELECT_FILTER: "Please select a search filter.",
    INVALID_PHONE_NUMBER: "Invalid phone number.",
    CALL_ADDED_SUCCESS: "Call added successfully.",
    CALL_COMPLETED_SUCCESS: "Call completed successfully.",
};

export const VALIDATION_PATTERNS = {
    PHONE_NUMBER: /^\d{10}$/,
};

export const SEARCH_FILTER_OPTIONS = {
    PHONE_NUMBER: "phoneNumber",
};

export const SEARCH_FILTER_LABELS = {
    phoneNumber: "Phone Number",
};

export const UI_CONFIG = {
    MODAL_MAX_WIDTH: 600,
    MODAL_WIDTH: 400,
    MODAL_PADDING: 3,
    MODAL_MARGIN_TOP: 8,
    MODAL_BORDER_RADIUS: 2,
    MARGIN_TOP: 2,
};
